export const DNI_VALUES = {
  type: 'DNI',
  length: 8,
};

export const CE_VALUES = {
  type: 'CE',
  length: 9,
};
